export default __webpack_public_path__ + "static/media/j11.b882fa83.jpg";